import { render, staticRenderFns } from "./LabelTaggingContainer.vue?vue&type=template&id=4120a2e2&"
import script from "./LabelTaggingContainer.vue?vue&type=script&lang=js&"
export * from "./LabelTaggingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4120a2e2')) {
      api.createRecord('4120a2e2', component.options)
    } else {
      api.reload('4120a2e2', component.options)
    }
    module.hot.accept("./LabelTaggingContainer.vue?vue&type=template&id=4120a2e2&", function () {
      api.rerender('4120a2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/LabelTaggingContainer.vue"
export default component.exports